import {
  createContext, useEffect, useMemo, useState,
} from 'react';
import { useTPlateEditorRef } from '../../../plate';

// eslint-disable-next-line no-spaced-func
export const NavbarDropdownOpenedMenuContext = createContext<{
  openedId: string | null,
  setOpenedId: (newId: string | null) => void,
}>({ openedId: null, setOpenedId: () => { } });

export function NavbarDropdownOpenedMenuProvider({ children }: { children: React.ReactNode }) {
  const [openedId, setOpenedId] = useState<string | null>(null);
  const editor = useTPlateEditorRef();

  const setId = (newId: string | null) => {
    if (newId === '' || newId === null) {
      editor.emitter.emit(
        'toolbar:navbar:dropdown:menu:close',
      );
    }
    setOpenedId(newId);
  };

  const value = useMemo(() => ({
    openedId,
    setOpenedId: setId,
  }), [openedId, setOpenedId]);

  // Hide opened dropdown when changing any menu's type,
  // since it's may resulting to opening dropdown for wrong type of menu.
  const handleChangedType = () => {
    setOpenedId(null);
    editor.emitter.emit('toolbar:navbar:dropdown:menu:close');
  };

  useEffect(() => {
    editor.emitter.on('toolbar:navbar:menu:update', handleChangedType);
    return () => {
      editor.emitter.off('toolbar:navbar:menu:update', handleChangedType);
    };
  }, []);

  return (
    <NavbarDropdownOpenedMenuContext.Provider
      value={value}
    >
      {children}
    </NavbarDropdownOpenedMenuContext.Provider>
  );
}
